export default "__VITE_ASSET__e8a731d0__"